import React, { Component } from "react";
import { Button, Checkbox, message } from "antd";
import { aceitarContrato, getTermoUso, logoutContaUnica } from "../Auth/actions";
import Loading from "../../components/Loading/index";

import "../../styles/css/pages/contract.css";

class Contract extends Component {
  state = {
    isAccept: false,
    isLoading: false,
    pdfUseTerm: null,
    moduloIcms: !!sessionStorage.getItem("icmsModule"),
  };

  async componentDidMount() {
    this.setState({ isLoading: true });
    getTermoUso()
      .then(url => this.setState({ pdfUseTerm: url, isLoading: false }))
      .catch((errors) => {
        message.error("Erro ao obter Termos de Uso.");
        this.setState({ isLoading: false });
      });
  }

  onCheck = () => {
    this.setState((state) => ({ isAccept: !state.isAccept }));
  };

  aceitoOnClick = async () => {
    await this.saveUseTermAcepted();
    window.location = "/bemvindo";
  };

  naoAceitoOnClick = () => {
    this.setState({ isLoading: true, visible: false });
    logoutContaUnica();
  };

  async saveUseTermAcepted() {
    this.setState({ isLoading: true });

    await aceitarContrato()
      .then(x => x.status ? message.success(x.message) : message.error(x.message))
      .catch((errors) => {
        localStorage.setItem("eRecuperadorAceito", false);
        message.error(
          "Erro ao comunicar com o Servidor. Tente novamente mais tarde"
        );
      });
  }

  render() {
    const { pdfUseTerm } = this.state;

    return (
      <div className="contract">
        <div className="contract__logo">
          <img
            src="https://images.e-auditoria.com.br/global/logos/png/erecuperador.png"
            alt="e-Recuperador"
          />
        </div>

        {this.state.isLoading ? <Loading visible={this.state.isLoading} /> : ""}

        <div className="contract__wrapper">
          {pdfUseTerm !== null ? (
            <iframe
              id="iframe-termo-uso"
              title="Termo de Uso"
              src={pdfUseTerm + "#view=fitH"}
            />
          ) : null}
        </div>

        <div className="contract__footer">
          <Checkbox onChange={this.onCheck}>
            Eu li e concordo com o contrato de uso
          </Checkbox>
          <div>
            <Button
              type="primary"
              disabled={!this.state.isAccept}
              onClick={() => this.aceitoOnClick()}
            >
              Aceito
            </Button>
            <Button type="danger" onClick={() => this.naoAceitoOnClick()}>
              Não aceito
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default Contract;
